import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const WorkspacePopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "WorkspacePopup" */ './Container'),
  'popup'
);
